import {
  Box,
  Container,
  Grid,
  GridItem,
  Heading,
  Image,
  Link,
  List,
  ListItem,
  Text,
} from "@chakra-ui/react";
import Benefits from "../img/Benefits.png";
import React from "react";
import { RightIcon } from "../components/Icons";
import {Helmet} from "react-helmet";
import {absoluteUrl} from "../components/Utils";

const ArticleThree = () => {
  return (
      <>
        <Helmet>
          <title>Welltower Medical Office For Lease - Benefits of Leasing vs. Owning Medical Office Buildings</title>
          <link rel="canonical" href={ absoluteUrl( "/benefits-of-leasing")} />
        </Helmet>
    <Box mt={"91px"}>
      <Container maxW={{ md: "85%", base: "100%" }} pt={8}>
        <Image src={Benefits} borderRadius={{ md: "30px", base: "12px" }} />
        <Grid
          mt={{ md: 20, base: 10 }}
          gap={{ md: 16, base: 4 }}
          gridTemplateColumns={"repeat(8,1fr)"}
        >
          <GridItem
            colSpan={{ md: 5, base: 8 }}
            px={{ md: 8, base: 2 }}
            pos={"relative"}
            _after={{
              content: { md: '""', base: "unset" },
              pos: "absolute",
              w: "1px",
              h: "100%",
              bgColor: "DarkTeal",
              right: "-5%",
              top: 0,
            }}
          >
            <Heading mb={10} color={"DarkBlue"}>
              Benefits of Leasing vs. Owning Medical Office Buildings
            </Heading>
            <Text>
              In the ever-evolving landscape of healthcare, professionals are
              increasingly realizing the advantages of leasing medical office
              space over owning real estate. Providers need to be able to focus
              on medical expertise and patients rather than real estate. This
              article explores the numerous benefits of leasing medical office
              space, with a particular focus on why partnering with Welltower
              Inc. can be a game-changer for healthcare practices.
            </Text>
            <List ms={{ md: 10, base: 6 }} listStyleType={"auto"}>
              <ListItem mt={6}>
                <Text fontSize={"2xl"} fontFamily={"Larken"}>
                  Capital Benefits
                </Text>
                <List ms={{ md: 10, base: 6 }} listStyleType={"circle"}>
                  <ListItem>
                    Invest your capital into your practice over acquiring pricey
                    real estate
                  </ListItem>
                  <ListItem>
                    Avoid expensive capital replacements like upgrades or
                    structural components
                  </ListItem>
                  <ListItem>
                    No need for long-term debt with high interest rates
                  </ListItem>
                  <ListItem>
                    Protection from real estate market fluctuations
                  </ListItem>
                  <ListItem>
                    Flexibility in suite design and future expansionary
                    capabilities without having to fund these changes out of
                    your own pocket
                  </ListItem>
                </List>
              </ListItem>
              <ListItem mt={6}>
                <Text fontSize={"2xl"} fontFamily={"Larken"}>
                  Property Management Benefits
                </Text>
                <List ms={{ md: 10, base: 6 }} listStyleType={"circle"}>
                  <ListItem>
                    Ensuring building systems and electronics are in proper
                    working order and most preventative maintenance will be
                    someone else’s concern. No need to manage various contracts
                    (cleaning, landscaping, security, etc.)
                  </ListItem>
                  <ListItem>
                    Unlikely to obtain scale discounts for contracts or services
                  </ListItem>
                  <ListItem>
                    Hiring and management of on-site maintenance staff is time
                    intensive and will distract from seeing patients
                  </ListItem>
                  <ListItem>
                    In a multi-tenant building, Landlord will take the burden of
                    management services to unrelated third-party tenants and
                    manage their expectations
                  </ListItem>
                  <ListItem>
                    Will not have to provide or pay for the costly accounting
                    services to reconcile and collect common area maintenance
                    charges from 3rd party tenants (and deal with tenant audits)
                  </ListItem>
                  <ListItem>
                    No need to worry about hiring attorneys to contest real
                    estate taxes when values go up
                  </ListItem>
                  <ListItem>
                    REIT owners are trained to deal with emergencies such as
                    fires, natural disasters, or other incidents and will deal
                    with insurance companies during these events
                  </ListItem>
                </List>
              </ListItem>
              <ListItem mt={6}>
                <Text fontSize={"2xl"} fontFamily={"Larken"}>
                  Leasing Benefits
                </Text>
                <List ms={{ md: 10, base: 6 }} listStyleType={"circle"}>
                  <ListItem>
                    Actively marketing and leasing vacant space is very time
                    consuming which will distract you from seeing patients
                  </ListItem>
                  <ListItem>
                    No need to provide third-party tenants with construction
                    allowances or pay broker commissions for new and renewal
                    deals freeing up those funds for delivering healthcare
                  </ListItem>
                  <ListItem>
                    Avoid hiring architects and construction project managers to
                    oversee 3rd party tenant space build-outs
                  </ListItem>
                  <ListItem>
                    Attorneys are required to prepare and negotiate lease
                    documents which is very costly and time consuming
                  </ListItem>
                </List>
              </ListItem>
              <ListItem mt={6}>
                <Text fontSize={"2xl"} fontFamily={"Larken"}>
                  Benefits of Partnering with Welltower
                </Text>
                <List ms={{ md: 10, base: 6 }} listStyleType={"circle"}>
                  <ListItem>
                    Expertise: Welltower’s tenants enjoy peace of mind knowing a
                    team of professionals specialized in managing outpatient
                    facilities is dedicated to helping their practices run
                    smoothly. In addition, the company works to create a
                    complementary mix of specialties within buildings to foster
                    cross-referral patterns among tenants.
                  </ListItem>
                  <ListItem>
                    Reach: A nationwide portfolio allows tenants to grow within
                    their current buildings or expand into new markets. In
                    addition, Welltower negotiates competitive pricing for
                    taxes, utilities, and other expenses to reduce tenants’
                    costs.
                  </ListItem>
                  <ListItem>
                    Quality: The quality of an outpatient medical building
                    directly correlates to the perception of the practices
                    within. Welltower only invests in buildings of the best
                    quality in the top markets associated with the strongest
                    healthcare systems. To maintain their long-term value,
                    buildings undergo continual, rigorous maintenance and
                    improvements.
                  </ListItem>
                  <ListItem>
                    Stability: Welltower acquires and develops buildings for
                    long-term ownership. Tenants can depend on having reliable
                    ownership throughout the life of their practice.
                  </ListItem>
                  <ListItem>
                    Service: Welltower prioritizes customer satisfaction from
                    our service center associates to our property management and
                    maintenance team in the field
                  </ListItem>
                </List>
              </ListItem>
            </List>
            <Text mt={6}>
              Leasing medical office space with Welltower Inc. offers a myriad
              of benefits, from capital and property management advantages to
              relationship and competitive benefits. Healthcare professionals
              can confidently focus on their core expertise and patient care,
              knowing that their real estate needs are in expert hands.
            </Text>
            <Text fontStyle={"italic"} mt={6}>
              The information on this website is for informational purposes only
              and not for the purpose of providing legal advice.
            </Text>
          </GridItem>
          <GridItem colSpan={{ md: 3, base: 8 }} px={{ md: 8, base: 2 }}>
            <Box pos={"sticky"} top={20}>
              <Text color={"DarkTeal"} fontSize={"2xl"}>
                Other Articles
              </Text>
              <List color={"DarkBlue"}>
                <ListItem
                  justifyContent={"space-between"}
                  alignItems={"center"}
                  borderBottom={"1px solid"}
                  borderColor={"#CED2D6"}
                  py={6}
                  px={4}
                  display={"flex"}
                >
                  <Link href="/what-is-mob">
                    <Text>
                      What is an MOB (Medical Office Building) and Why It
                      Matters in Healthcare?
                    </Text>
                  </Link>
                  <RightIcon />
                </ListItem>
                <ListItem
                  justifyContent={"space-between"}
                  alignItems={"center"}
                  borderBottom={"1px solid"}
                  borderColor={"#CED2D6"}
                  py={6}
                  px={4}
                  display={"flex"}
                >
                  <Link href="/healthcare-real-estate-terms-simplified">
                    <Text>Healthcare Real Estate Leasing Terms Simplified</Text>
                  </Link>
                  <RightIcon />
                </ListItem>
                <ListItem
                  justifyContent={"space-between"}
                  alignItems={"center"}
                  borderBottom={"1px solid"}
                  borderColor={"#CED2D6"}
                  py={6}
                  px={4}
                  display={"flex"}
                >
                  <Link href="/understanding-the-leasing-process">
                    <Text>
                      Understanding the Leasing Process: What to expect when
                      leasing a medical office space for your practice
                    </Text>
                  </Link>
                  <RightIcon />
                </ListItem>
              </List>
            </Box>
          </GridItem>
        </Grid>
      </Container>
    </Box>
        </>
  );
};

export default ArticleThree;
